export var TransactionTypeEnum;
(function (TransactionTypeEnum) {
    TransactionTypeEnum["RENT"] = "rent";
    TransactionTypeEnum["SELL"] = "sell";
})(TransactionTypeEnum || (TransactionTypeEnum = {}));
